export const MAP_LAYERS = [
    {
        id: 'osm',
        name: 'OpenStreetMap',
        type: 'tile',
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    },
    {
        id: 'satellite',
        name: 'Satellite (Esri)',
        type: 'tile',
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
    },
    {
        id: 'google_roadmap',
        name: 'Google Maps',
        type: 'tile',
        url: 'https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
        attribution: '&copy; Google Maps'
    },
    {
        id: 'google_traffic',
        name: 'Google Traffic',
        type: 'tile',
        url: 'https://mt1.google.com/vt/lyrs=m,traffic&x={x}&y={y}&z={z}',
        attribution: '&copy; Google Maps'
    },
    {
        id: 'rainviewer',
        name: 'RainViewer (Radar)',
        type: 'rainviewer',
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', // Base map
        overlayUrl: null, // To be filled dynamically
        attribution: '&copy; <a href="https://www.rainviewer.com">RainViewer</a>'
    },
    {
        id: 'google_satellite',
        name: 'Google Satellite',
        type: 'tile',
        url: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
        attribution: '&copy; Google Maps'
    },
    {
        id: 'google_hybrid',
        name: 'Google Hybrid',
        type: 'tile',
        url: 'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
        attribution: '&copy; Google Maps'
    },
    {
        id: 'google_terrain',
        name: 'Google Terrain',
        type: 'tile',
        url: 'https://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',
        attribution: '&copy; Google Maps'
    },
    {
        id: 'topo',
        name: 'OpenTopoMap',
        type: 'tile',
        url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
        attribution: 'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
    }
];
